<template>
  <Layout>
    <PageHeader :title="$t('fixed_assets.statuses')" />
    <div :dir="$i18n.locale == 'ar' ? 'ltr' : 'ltr'" class="row">
      <div class="row">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <div class="search-box chat-search-box w-50"></div>
              </div>
              <div
                class="col-6"
                style="display: flex; justify-content: flex-end"
              >
                <button
                  @click="addAssetStatus()"
                  type="button"
                  class="btn btn-light float-end mb-4"
                >
                  <span
                    class="bx bxs-plus-circle float-end fa-2x"
                    style="color: #2a3042 !important"
                  ></span>
                </button>
              </div>
            </div>
            <div class="table-responsive">
              <table
                :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
                class="table table-striped table-hover mb-0 mt-4"
              >
                <thead>
                  <tr
                    class="text-light"
                    style="background-color: #2a3042 !important"
                  >
                    <th scope="col">{{ $t("fixed_assets.id") }}</th>
                    <th scope="col">{{ $t("fixed_assets.label") }}</th>
                    <th scope="col">{{ $t("fixed_assets.label_en") }}</th>

                    <th scope="col">{{ $t("fixed_assets.created") }}</th>
                    <th scope="col">{{ $t("fixed_assets.updated") }}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(cls, index) in AssetStatuses" :key="cls" class="">
                    <td>{{ index + 1 }}</td>
                    <td>{{ cls?.name }}</td>
                    <td>{{ cls?.name_en }}</td>

                    <td>{{ cls?.created.split("T")[0] }}</td>
                    <td>{{ cls?.updated.split("T")[0] }}</td>
                    <td class="flex">
                      <a
                        style="margin-inline-end: 4px"
                        class="btn btn-primary btn-md d-inline"
                        @click="editAssetStatus(cls)"
                        data-bs-toggle="modal"
                        role="button"
                        >{{ $t("popups.edit") }}</a
                      >
                      <a
                        class="btn btn-danger btn-md d-inline"
                        href="javascript: void(0);"
                        role="button"
                        @click="deleteAssetStatus(cls)"
                        >{{ $t("popups.delete") }}</a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- end  table -->

      <!--end-->
    </div>

    <!--End SubClasses Modal-->
  </Layout>
</template>
<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      AssetStatuses: [],
      fixedAssetsSubClasses: [],
      cls: {},
    };
  },
  methods: {
    // fixed assets class methods
    addAssetStatus() {
      var data = {
        title: "popups.add",
        inputs: [
          {
            model: "name",
            type: "text",
            label: "fixed_assets.label",
            restrictions: { required: true },
          },
          {
            model: "name_en",
            type: "text",
            label: "fixed_assets.label_en",
            restrictions: { required: true },
          },
        ],
        buttons: [
          {
            text: "popups.add",
            closer: true,
            color: "primary",
            handler: (obj) => {
              obj.branch_id = this.branch_id;
              this.http.post("fixed-assets/asset-statuses", obj).then(() => {
                this.getAssetStatuses();
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    editAssetStatus(cls) {
      var data = {
        title: "popups.edit",
        inputs: [
          {
            model: "name",
            type: "text",
            label: "fixed_assets.label",
            value: cls.name,
          },
          {
            model: "name_en",
            type: "text",
            label: "fixed_assets.label_en",
            value: cls.name_en,
          },
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http
                .put("fixed-assets/asset-statuses", cls.id, obj)
                .then(() => {
                  this.getAssetStatuses();
                });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    deleteAssetStatus(cls) {
      var data = {
        title: "popups.delete",
        msg: "popups.delmessage",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          this.http.delete("fixed-assets/asset-statuses", cls.id).then(() => {
            this.getAssetStatuses();
          });
        }
      });
    },
    getAssetStatuses() {
      this.http.get("fixed-assets/asset-statuses").then((res) => {
        this.AssetStatuses = res.data;
      });
    },
  },
  created() {
    this.getAssetStatuses();
  },
};
</script>
